import type React from 'react';
import { FormattedMessage } from 'react-intl';

import { type SeoJobRoleLocations } from '@xing-com/crate-common-graphql-types';
import { Link } from '@xing-com/link';

export const CitiesFormattedMessage = (
  jobRole: string,
  cities: Array<SeoJobRoleLocations>
): React.ReactNode => {
  switch (cities.length) {
    case 0:
      return;
    case 1:
      return (
        <FormattedMessage
          id="XJM_JOBS_SEO_ROLE_FAQ_TOP_CITY_ANSWER"
          values={{
            jobRole,
            firstCity: <Link to={cities[0].url}>{cities[0].name}</Link>,
          }}
        />
      );
    case 2:
      return (
        <FormattedMessage
          id="XJM_JOBS_SEO_ROLE_FAQ_TOP_TWO_CITIES_ANSWER"
          values={{
            jobRole,
            firstCity: <Link to={cities[0].url}>{cities[0].name}</Link>,
            secondCity: <Link to={cities[1].url}>{cities[1].name}</Link>,
          }}
        />
      );
    default:
      return (
        <FormattedMessage
          id="XJM_JOBS_SEO_ROLE_FAQ_TOP_THREE_CITIES_ANSWER"
          values={{
            jobRole,
            firstCity: <Link to={cities[0].url}>{cities[0].name}</Link>,
            secondCity: <Link to={cities[1].url}>{cities[1].name}</Link>,
            thirdCity: <Link to={cities[2].url}>{cities[2].name}</Link>,
          }}
        />
      );
  }
};
